import { render } from "./VacancyEditor.vue?vue&type=template&id=70cf6f94&scoped=true"
import script from "./VacancyEditor.vue?vue&type=script&lang=js"
export * from "./VacancyEditor.vue?vue&type=script&lang=js"

import "./VacancyEditor.vue?vue&type=style&index=0&id=70cf6f94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70cf6f94"]])

export default __exports__